<template>
    <div>
        <FunctionPopularityFilters
            @runGetResults="runGetResults"
            v-model:inputsResetting="inputsResetting"
        />
        <FunctionPopularityTable
            :items="items"
            :loading="loading"
            :time="time"
            :itemsPerPage="defaultTake ?? 10"
        />
    </div>
</template>
<script setup>
import { ref, onMounted, getCurrentInstance } from 'vue'
import { useStore } from 'vuex'
import { useRoute } from 'vue-router'
import FunctionPopularityFilters from './FunctionPopularityFilters.vue'
import FunctionPopularityTable from './FunctionPopularityTable.vue'

const props = defineProps({
    defaultTake: { type: Number, required: false },
})

const store = useStore()
const route = useRoute()
const { proxy } = getCurrentInstance()

const items = ref([])
const loading = ref(true)
const time = ref(0)
const latestRunId = ref(0)
const inputsResetting = ref(false)
const firstRun = ref(true)

onMounted(() => {
    runGetResults({
        type: 1,
        selectedDisciplines: [],
        selectedRegions: [],
        take: props.defaultTake ?? 10,
        selectedTimePeriod: 1,
        selectedClients: ['webui', 'excel', 'grasshopper'],
    })
})

function runGetResults({
    type,
    selectedDisciplines,
    selectedRegions,
    take,
    selectedTimePeriod,
    selectedClients,
}) {
    if (!firstRun.value) {
        if (proxy.$posthog) {
            proxy.$posthog.capture('functionPopularityFilter', {
                location: route.name,
                filters: {
                    type,
                    selectedDisciplines,
                    selectedRegions,
                    take,
                    selectedTimePeriod,
                    selectedClients,
                },
            })
        }
    } else {
        firstRun.value = false
    }
    const runId = Math.random()
    latestRunId.value = runId
    getResults(
        runId,
        type,
        selectedDisciplines,
        selectedRegions,
        take,
        selectedTimePeriod,
        selectedClients
    )
}

async function getResults(
    runId,
    type,
    selectedDisciplines,
    selectedRegions,
    take,
    selectedTimePeriod,
    selectedClients
) {
    items.value = []
    loading.value = true
    const startTime = new Date()
    const res = await store.dispatch('getFunctionPopularity', {
        type,
        disciplines: selectedDisciplines,
        regions: selectedRegions,
        clients: selectedClients,
        take,
        timePeriod: selectedTimePeriod,
    })
    if (runId === latestRunId.value) {
        items.value = Array.isArray(res) ? res : []
        time.value = new Date() - startTime
        loading.value = false
        inputsResetting.value = false
    }
}
</script>
